<ion-chip mode="ios" [color]="color" [outline]="true" class="chip-tag-sale">
  <ion-icon
    [icon]="promoData.Bonificacion ? 'getm-gift-fill' : 'getm-discount-fill'"
    [color]="color"
    class="icon-discount"
  ></ion-icon>

  <ng-container [ngSwitch]="promoData.TipoPromocion">
    <ng-container *ngSwitchCase="'ESTATICO'">
      <getm-price-display
        [discount]="promoData.PrecioDescuento"
        discountColor="medium"
        [price]="promoData.PrecioOriginal"
        priceColor="dark"
      ></getm-price-display>
    </ng-container>

    <ng-container *ngSwitchCase="'ESCALERA'">
      <ion-label color="getm-neutral-dark" class="tag-text-center">
        {{ 'Labels.save-up-to' | translate }}
        <ion-text [color]="color" class="label-percent">
          {{ levelDiscount | percent : '1.0-2' }}
        </ion-text>
      </ion-label>
    </ng-container>

    <ng-container *ngSwitchCase="'DINAMICO'">
      <ion-label color="getm-neutral-dark" class="discover-discount">
        {{ 'Labels.discover-discount' | translate }}
      </ion-label>
    </ng-container>

    <ng-container *ngSwitchCase="'BONIFICACION'">
      <ion-label color="getm-neutral-dark" class="tag-text-center">
        {{ 'Labels.product' | translate }}
        <ion-text class="free" [color]="color">
          {{ 'Labels.free' | translate }}
        </ion-text>
      </ion-label>
    </ng-container>
  </ng-container>
</ion-chip>
